import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Shield } from 'lucide-react';

const Datenschutz = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="relative bg-gradient-to-r from-blue-700 to-blue-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Shield className="w-16 h-16 mx-auto mb-4" />
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {language === 'de' ? 'Datenschutzerklärung' : 'Privacy Policy'}
          </h1>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            
            <h2 className="text-2xl font-bold mb-4">Allgemeiner Hinweis und Pflichtinformationen</h2>
            
            <h3 className="text-xl font-semibold mt-6 mb-3">Benennung der verantwortlichen Stelle</h3>
            <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
            <p className="text-lg">
              <strong>Surf- und Kitemotion</strong><br />
              Peter Müller<br />
              Palm Royale Soma Bay (ex InterContinental Abu Soma)<br />
              Red Sea Hurghada Ägypten
            </p>
            <p>
              Die verantwortliche Stelle entscheidet allein oder gemeinsam mit anderen über die Zwecke und 
              Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, Kontaktdaten o. Ä.).
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
            <p>
              Nur mit Ihrer ausdrücklichen Einwilligung sind einige Vorgänge der Datenverarbeitung möglich. 
              Ein Widerruf Ihrer bereits erteilten Einwilligung ist jederzeit möglich. Für den Widerruf genügt 
              eine formlose Mitteilung per E-Mail. Die Rechtmäßigkeit der bis zum Widerruf erfolgten 
              Datenverarbeitung bleibt vom Widerruf unberührt.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Recht auf Beschwerde bei der zuständigen Aufsichtsbehörde</h3>
            <p>
              Als Betroffener steht Ihnen im Falle eines datenschutzrechtlichen Verstoßes ein Beschwerderecht 
              bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde bezüglich datenschutzrechtlicher 
              Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem sich der Sitz unseres 
              Unternehmens befindet.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Recht auf Datenübertragbarkeit</h3>
            <p>
              Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines 
              Vertrags automatisiert verarbeiten, an sich oder an Dritte aushändigen zu lassen. Die Bereitstellung 
              erfolgt in einem maschinenlesbaren Format. Sofern Sie die direkte Übertragung der Daten an einen 
              anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Recht auf Auskunft, Berichtigung, Sperrung, Löschung</h3>
            <p>
              Sie haben jederzeit im Rahmen der geltenden gesetzlichen Bestimmungen das Recht auf unentgeltliche 
              Auskunft über Ihre gespeicherten personenbezogenen Daten, Herkunft der Daten, deren Empfänger und 
              den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">SSL- bzw. TLS-Verschlüsselung</h3>
            <p>
              Aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, die Sie an uns als 
              Seitenbetreiber senden, nutzt unsere Website eine SSL-bzw. TLS-Verschlüsselung. Damit sind Daten, 
              die Sie über diese Website übermitteln, für Dritte nicht mitlesbar. Sie erkennen eine verschlüsselte 
              Verbindung an der „https://" Adresszeile Ihres Browsers und am Schloss-Symbol in der Browserzeile.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Server-Log-Dateien</h3>
            <p>In Server-Log-Dateien erhebt und speichert der Provider der Website automatisch Informationen, 
            die Ihr Browser automatisch an uns übermittelt. Dies sind:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Browsertyp und Browserversion</li>
              <li>Verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
            <p>
              Es findet keine Zusammenführung dieser Daten mit anderen Datenquellen statt. Grundlage der 
              Datenverarbeitung bildet Art. 6 Abs. 1 lit. b DSGVO.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Kontaktformular</h3>
            <p>
              Per Kontaktformular übermittelte Daten werden einschließlich Ihrer Kontaktdaten gespeichert, 
              um Ihre Anfrage bearbeiten zu können oder um für Anschlussfragen bereitzustehen. Eine Weitergabe 
              dieser Daten findet ohne Ihre Einwilligung nicht statt.
            </p>
            <p>
              Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt ausschließlich auf Grundlage 
              Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Ein Widerruf Ihrer bereits erteilten Einwilligung 
              ist jederzeit möglich.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Cookies</h3>
            <p>
              Unsere Website verwendet Cookies. Das sind kleine Textdateien, die Ihr Webbrowser auf Ihrem Endgerät 
              speichert. Cookies helfen uns dabei, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.
            </p>
            <p>
              Einige Cookies sind "Session-Cookies." Solche Cookies werden nach Ende Ihrer Browser-Sitzung von selbst 
              gelöscht. Hingegen bleiben andere Cookies auf Ihrem Endgerät bestehen, bis Sie diese selbst löschen.
            </p>
            <p>
              Mit einem modernen Webbrowser können Sie das Setzen von Cookies überwachen, einschränken oder unterbinden. 
              Die Deaktivierung von Cookies kann eine eingeschränkte Funktionalität unserer Website zur Folge haben.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Google Analytics</h3>
            <p>
              Unsere Website verwendet Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die 
              Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.
            </p>
            <p>
              Google Analytics verwendet "Cookies." Mittels Cookie erzeugte Informationen über Ihre Benutzung 
              unserer Website werden an einen Server von Google übermittelt und dort gespeichert.
            </p>
            <p>
              Das Setzen von Google-Analytics-Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. 
              Als Betreiber dieser Website haben wir ein berechtigtes Interesse an der Analyse des Nutzerverhaltens.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">YouTube und Vimeo</h3>
            <p>
              Für Integration und Darstellung von Videoinhalten nutzt unsere Website Plugins von YouTube und Vimeo. 
              Bei Aufruf einer Seite mit integriertem Plugin wird eine Verbindung zu den Servern hergestellt.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Auskunft und Fragen</h3>
            <p>
              Falls Sie Fragen zu dieser Datenschutzerklärung haben, z.B. zur Einsicht oder Aktualisierung Ihrer 
              personenbezogenen Daten, wenden Sie sich bitte an:{' '}
              <a href="mailto:peter@surfmotion.com" className="text-cyan-600 hover:text-cyan-800">
                peter@surfmotion.com
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Datenschutz;
